var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 27.9997C21.7317 27.9997 27.9997 21.7317 27.9997 13.9998C27.9997 6.26794 21.7317 0 13.9998 0C6.26794 0 0 6.26794 0 13.9998C0 21.7317 6.26794 27.9997 13.9998 27.9997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1452 14.4228C15.1452 16.869 13.0926 18.8456 10.5726 18.8456C8.05258 18.8456 6 16.8886 6 14.4228C6 11.957 8.05258 10 10.5726 10C13.0926 10 15.1452 11.9766 15.1452 14.4228Z",
    fill: "#24126A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1656 14.4223C20.1656 16.7315 19.1495 18.5907 17.8895 18.5907C16.6295 18.5907 15.6133 16.7315 15.6133 14.4223C15.6133 12.113 16.6295 10.2539 17.8895 10.2539C19.1292 10.2539 20.1656 12.1326 20.1656 14.4223Z",
    fill: "#24126A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 14.4253C22.1981 16.4801 21.8323 18.1632 21.3852 18.1632C20.9381 18.1632 20.5723 16.4801 20.5723 14.4253C20.5723 12.3705 20.9381 10.6875 21.3852 10.6875C21.8527 10.6875 22.1981 12.3705 22.1981 14.4253Z",
    fill: "#24126A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedium);
export default __webpack_public_path__ + "res/media/social-medium.9c43d4c6b99026d9138d0b0869f0b352.svg";
export { ForwardRef as ReactComponent };